import {
  desktopAndUpLinaria,
  SIZE,
  SPACING,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import styled from 'styled-components';
import {HeightCalcWrapper} from '../../features/HeightCalcWrapper/HeightCalcWrapper';

export const heroImageHeight =
  'height: calc(100vh - var(--layout-header-height, 0) - 100px);';

export const StyledHeightCalcWrapper = styled(HeightCalcWrapper)`
  display: grid;
  align-items: flex-end;
  justify-items: center;

  & > * {
    grid-row: 1;
    grid-column: 1;
    z-index: 1;
  }
`;

export const StoriesWrapper = styled.section`
  display: flex;
  flex-direction: row;
  gap: ${SPACING['Y.Xl']};
  flex-wrap: wrap;
  padding: 0 ${SPACING['Y.Lg']} ${SPACING['X.Xl']} ${SPACING['Y.Lg']};
  margin-bottom: ${SPACING['Y.Lg']};
  width: 100%;
  max-width: 1800px;
  margin: auto;

  & > * {
    flex: 0 1 100%;
  }

  ${tabletAndUpLinaria(`
    padding: ${SPACING['X.Xl2']} ${SIZE.U5};
    gap: 53px 8px;
    margin-bottom: 64px;

    
    & > * {
      flex-basis: calc(50% - 4px);
    }
  `)}

  ${desktopAndUpLinaria(`
    padding: ${SPACING['X.Xl6']} ${SIZE.U15};
  `)}
`;
